import React from 'react';

import PropTypes from 'prop-types';

import { IconCheckbox } from './style';

const Checkbox = ({ checked = false, ...props }) => (
  <IconCheckbox
    className={checked ? 'icon-button-checkbox-on' : 'icon-button-checkbox-off'}
    checked={checked}
    {...props}
  />
);

Checkbox.propTypes = {
  checked: PropTypes.bool
};

export default Checkbox;
